// src/constants/accessPermissions.js

export const ACCESS = {
  DASHBOARD: {
    VIEW_DASHBOARD: "view-dashboard",
    VIEW_DASHBOARD_PANEL: "view-dashboard-panel",
    VIEW_ACCOUNT_BALANCE: "view-dashboard-account-balance",
    VIEW_MONTHLY_INCOME: "view-dashboard-monthly-income",
    VIEW_MONTHLY_EXPENSE: "view-dashboard-monthly-expense",
    VIEW_OUTSTANDING_LOAN: "view-dashboard-outstanding-loan",
    VIEW_INCOME_EXPENSE_TREND: "view-dashboard-income-expense-trend",
  },

  USER_PANEL: {
    VIEW_PANEL: "view-user-panel",
  },

  USER: {
    VIEW_USER_LIST: "view-user-list",
    VIEW_PROFILE: "view-user-profile",
    EDIT_USER: "edit-user",
    MANAGE_USER_ROLES: "manage-user-roles",
  },

  VEHICLE_STOCK: {
    VIEW_VEHICLE_STOCK: "view-vehicle-stock",
  },
  BRAND: {
    VIEW_BRAND_LIST: "view-brand-list",
  },

  MODEL: {
    VIEW_MODEL_LIST: "view-model-list",
  },
  SETTINGS: {
    VIEW_SETTINGS_PANEL: "view-settings-panel",
  },

  LOCATION: {
    VIEW_LOCATION_LIST: "view-location-list",
  },

  STATUS: {
    VIEW_STATUS_LIST: "view-status-list",
  },

  COLOR: {
    VIEW_COLOR_LIST: "view-color-list",
  },

  FEATURE: {
    VIEW_FEATURE_LIST: "view-feature-list",
  },

  PACKAGE: {
    VIEW_PACKAGE_LIST: "view-package-list",
  },

  YEAR: {
    VIEW_YEAR_LIST: "view-year-list",
  },

  ENGINE_CC: {
    VIEW_ENGINE_CC_LIST: "view-engine-cc-list",
  },

  CHASSIS_CODE: {
    VIEW_CHASSIS_CODE_LIST: "view-chassis-code-list",
  },

  ENGINE_CODE: {
    VIEW_ENGINE_CODE_LIST: "view-engine-code-list",
  },

  FUEL_TYPE: {
    VIEW_FUEL_TYPE_LIST: "view-fuel-type-list",
  },

  ENGINE_TYPE: {
    VIEW_ENGINE_TYPE_LIST: "view-engine-type-list",
  },

  KEY_TYPE: {
    VIEW_KEY_TYPE_LIST: "view-key-type-list",
  },

  AUCTION_GRADE: {
    VIEW_AUCTION_GRADE_LIST: "view-auction-grade-list",
  },

  TRANSMISSION: {
    VIEW_TRANSMISSION_LIST: "view-transmission-list",
  },

  SHOWROOM_PANEL: {
    VIEW_PANEL: "view-showroom-panel",
  },

  SHOWROOM: {
    VIEW_SHOWROOM_LIST: "view-showroom-list",
    VIEW_PROFILE: "view-showroom-profile",
    CREATE: "create-showroom",
    EDIT: "edit-showroom",
    DELETE: "delete-showroom",
  },

  EMPLOYEE_MANAGEMENT: {
    VIEW_PANEL: "view-employee-management-panel",
  },

  EMPLOYEE: {
    VIEW_LIST: "view-employee-list",
    VIEW: "view-employee",
    ADD: "add-employee",
    EDIT: "edit-employee",
    DELETE: "delete-employee",
    GRANT_ACCESS: "grant-employee-access",
    REVOKE_ACCESS: "revoke-employee-access",
    ASSIGN_ROLES: "assign-employee-roles",
    VIEW_ACTIVITY_LOG: "view-employee-activity-log",
  },

  EMPLOYEE_DEPARTMENT: {
    VIEW_LIST: "view-employee-department-list",
    VIEW: "view-employee-department",
    ADD: "add-employee-department",
    EDIT: "edit-employee-department",
    DELETE: "delete-employee-department",
  },

  EMPLOYEE_DESIGNATION: {
    VIEW_LIST: "view-employee-designation-list",
    VIEW: "view-employee-designation",
    ADD: "add-employee-designation",
    EDIT: "edit-employee-designation",
    DELETE: "delete-employee-designation",
  },

  ATTENDANCE: {
    VIEW_PANEL: "view-attendance-panel",
    CHECK_IN: "check-in-attendance",
    VIEW_LIST: "view-attendance-list",
    ADD: "add-attendance",
    EDIT: "edit-attendance",
    DELETE: "delete-attendance",
    VIEW_REPORT: "view-attendance-report",
    EXPORT_DAILY_PDF: "export-attendance-daily-pdf",
    EXPORT_MONTHLY_PDF: "export-attendance-monthly-pdf",
    VIEW_SETTINGS: "view-attendance-settings",
    EDIT_SETTINGS: "edit-attendance-settings",
  },

  LEAVE: {
    VIEW_PANEL: "view-leave-panel",
    CREATE_REQUEST: "create-leave-request",
    VIEW_LIST: "view-leave-list",
    APPROVE: "approve-leave-request",
    MANAGE_TYPES: "manage-leave-types",
    MANAGE_BALANCES: "manage-leave-balances",
    MANAGE_HOLIDAYS: "manage-holidays",
  },

  STOCK: {
    VIEW_STOCK_LIST: "view-stock-list",
    CREATE: "create-stock",
    EDIT: "edit-stock",
    DELETE: "Delete Stock",
    VIEW_DETAILS: "view-stock-details",
    VIEW_IMPORTER: "view-stock-importer",
    CREATE_IMPORTER: "create-stock-importer",
    EDIT_IMPORTER: "edit-stock-importer",
    FILTER_IMPORTER: "filter-stock-importer",
    VIEW_STOCK_PUBLISHMENT: "view-stock-publishment",
    CREATE_STOCK_PUBLISHABLE_PLATFORM: "create-stock-publishable-platform",
    EDIT_STOCK_PUBLISHABLE_PLATFORM: "edit-stock-publishable-platform",
  },
  STOCK_PANEL: {
    VIEW_PANEL: "view-stock-panel",
  },

  MESSAGE: {
    VIEW_CONTACT_MESSAGE_LIST: "view-contact-message-list",
  },
  VEHICLE_MOVEMENT_TYPE: {
    VIEW_LIST: "view-vehicle-movement-type-list",
    VIEW: "view-vehicle-movement-type",
    EDIT: "edit-vehicle-movement-type",
    DELETE: "delete-vehicle-movement-type",
  },
  VEHICLE_MOVEMENT: {
    VIEW_LIST: "view-vehicle-movement-list",
    VIEW_KEY_LIST: "view-vehicle-movement-key-list",
    VIEW: "view-vehicle-movement",
    EDIT: "edit-vehicle-movement",
    DELETE: "delete-vehicle-movement",
    MOVEMENT_PASS_PDF: "view-vehicle-movement-pass-pdf",
    HANDOVER_PDF: "view-vehicle-movement-handover-pdf",
    BRTA_INSPECTION_PDF: "view-vehicle-movement-brta-inspection-pdf",
    VIEW_DAILY_AUDIT: "view-vehicle-daily-audit-list",
    ADD_DAILY_AUDIT: "add-vehicle-daily-audit",
    REOPEN_DAILY_AUDIT: "reopen-vehicle-daily-audit",
  },
  VEHICLE_FUEL_PANEL: {
    VIEW: "view-vehicle-fuel-panel",
  },
  VEHICLE_FUEL_STOCK: {
    VIEW_LIST: "view-vehicle-fuel-stock-list",
    VIEW: "view-vehicle-fuel-stock",
    EDIT: "edit-vehicle-fuel-stock",
    DELETE: "delete-vehicle-fuel-stock",
  },
  VEHICLE_FUEL_USE: {
    VIEW_LIST: "view-vehicle-fuel-use-list",
    VIEW: "view-vehicle-fuel-use",
    EDIT: "edit-vehicle-fuel-use",
    DELETE: "delete-vehicle-fuel-use",
  },

  VEHICLE_MOVEMENT_PANEL: {
    VIEW: "view-vehicle-movement-panel",
  },

  ROLE: {
    VIEW_ROLE_LIST: "view-role-list",
  },
  PERMISSION: {
    VIEW_PERMISSION_LIST: "view-permission-list",
  },
  MODULE: {
    VIEW_MODULE_LIST: "view-module-list",
  },

  ROLE_PERMISSION: {
    VIEW_ROLE_PERMISSION: "view-role-permission",
    VIEW_MODULES: "view-modules",
    VIEW_ROLES: "view-roles",
    VIEW_PERMISSIONS: "view-permissions",
    ASSIGN_ROLE_PERMISSIONS: "assign-permissions-to-role",
  },
  VEHICLE_IMPORTER: {
    VIEW_VEHICLE_IMPORTER_LIST: "view-vehicle-importer-list",
    VIEW_VEHICLE_IMPORTER: "view-vehicle-importer",
    CREATE_VEHICLE_IMPORTER: "create-vehicle-importer",
    EDIT_VEHICLE_IMPORTER: "edit-vehicle-importer",
    DELETE_VEHICLE_IMPORTER: "delete-vehicle-importer",
    RESTORE_VEHICLE_IMPORTER: "restore-vehicle-importer",
    FORCE_DELETE_VEHICLE_IMPORTER: "force-delete-vehicle-importer",
  },
  CONTENT_MANAGER: {
    VIEW_CONTENT_MANAGER: "view-content-manager",
    VIEW_VEHICLE_CONTENT_LIST: "view-vehicle-content-list",
  },
  VEHICLE_CONTENT: {
    VIEW_VEHICLE_CONTENT_LIST: "view-vehicle-content-list",
    ADD_VEHICLE_CONTENT: "add-vehicle-content",
    EDIT_VEHICLE_CONTENT: "edit-vehicle-content",
    DELETE_VEHICLE_CONTENT: "delete-vehicle-content",
  },

  JOB: {
    VIEW_GRID: "view-jobs",
    VIEW_DETAILS: "view-job-details",
    VIEW_CATEGORIES: "view-job-categories",
    APPLY: "apply-jobs",
    VIEW_CANDIDATES: "view-candidates",
    VIEW_CANDIDATE_DETAILS: "view-candidate-details",
  },
  CUSTOMER_PANEL: {
    VIEW: "view-customer-panel",
  },
  CUSTOMER: {
    VIEW_LIST: "view-customer-list",
    ADD: "add-customer",
    EDIT: "edit-customer",
    DELETE: "delete-customer",
  },
  // Accessories Management
  ACCESSORIES_MANAGEMENT: {
    VIEW: "view-accessories-management-panel",
  },

  ACCESSORIES: {
    VIEW_LIST: "view-accessories-list",
    ADD: "add-accessories",
    EDIT: "edit-accessories",
    DELETE: "delete-accessories",
  },
  ACCESSORIES_COMPANY: {
    VIEW_LIST: "view-accessories-company-list",
    ADD: "add-accessories-company",
    EDIT: "edit-accessories-company",
    DELETE: "delete-accessories-company",
  },
  ACCESSORIES_STOCK: {
    VIEW_LIST: "view-accessories-stock-list",
    ADD: "add-accessories-stock",
    EDIT: "edit-accessories-stock",
    DELETE: "delete-accessories-stock",
  },
  UNIT: {
    VIEW_LIST: "view-unit-list",
    ADD: "add-unit",
    EDIT: "edit-unit",
    DELETE: "delete-unit",
  },
  ACCESSORIES_USAGE: {
    VIEW_LIST: "view-accessories-use-list",
    ADD: "add-accessories-use",
    EDIT: "edit-accessories-use",
    DELETE: "delete-accessories-use",
  },
  ACCESSORY_USE_REQUEST: {
    VIEW_LIST: "view-accessory-use-request-list",
    ADD: "add-accessory-use-request",
    EDIT: "edit-accessory-use-request",
    DELETE: "delete-accessory-use-request",
  },
  CAR_CARE_SERVICE: {
    VIEW_LIST: "view-car-care-service-list",
    ADD: "add-car-care-service",
    EDIT: "edit-car-care-service",
    DELETE: "delete-car-care-service",
  },
  SERVICE_INVOICE: {
    VIEW_LIST: "view-service-invoice-list",
    VIEW: "view-service-invoice",
    ADD: "add-service-invoice",
    EDIT: "edit-service-invoice",
    DELETE: "delete-service-invoice",
    ADD_PAYMENT: "add-service-invoice-payment",
    REMOVE_PAYMENT: "remove-service-invoice-payment",
  },
  CAR_CARE_SERVICE_CENTER: {
    VIEW_LIST: "view-car-care-service-center-list",
    ADD: "add-car-care-service-center",
    EDIT: "edit-car-care-service-center",
    DELETE: "delete-car-care-service-center",
  },
  CAR_CARE_ACCOUNT: {
    VIEW_LIST: "view-car-care-account-list",
    ADD: "add-car-care-account",
    EDIT: "edit-car-care-account",
    DELETE: "delete-car-care-account",
  },
  VEHICLE_STOCK_INVENTORY: {
    VIEW_LIST: "view-vehicle-stock-inventory-list",
    VIEW: "view-vehicle-stock-inventory",
    ADD: "add-vehicle-stock-inventory",
    EDIT: "edit-vehicle-stock-inventory",
    DELETE: "delete-vehicle-stock-inventory",
  },
  INVENTORY_ACCESSORY: {
    VIEW_LIST: "view-inventory-accessory-list",
    ADD: "add-inventory-accessory",
    EDIT: "edit-inventory-accessory",
    DELETE: "delete-inventory-accessory",
  },
  ACCOUNT_MANAGEMENT: {
    VIEW: "view-account-management-panel",
  },
  ACCOUNT_PAYMENT_METHOD: {
    VIEW_LIST: "view-account-payment-method-list",
    ADD: "add-account-payment-method",
    EDIT: "edit-account-payment-method",
    DELETE: "delete-account-payment-method",
  },
  ACCOUNT_BANK_ACCOUNT: {
    VIEW_LIST: "view-account-bank-account-list",
    ADD: "add-account-bank-account",
    EDIT: "edit-account-bank-account",
    DELETE: "delete-account-bank-account",
  },
  ACCOUNT_ACCOUNT_TYPE: {
    VIEW_LIST: "view-account-account-type-list",
    ADD: "add-account-account-type",
    EDIT: "edit-account-account-type",
    DELETE: "delete-account-account-type",
  },
  ACCOUNT_TRANSACTION_TYPE: {
    VIEW_LIST: "view-account-transaction-type-list",
    ADD: "add-account-transaction-type",
    EDIT: "edit-account-transaction-type",
    DELETE: "delete-account-transaction-type",
  },
  ACCOUNT_EXPENSE_TYPE: {
    VIEW_LIST: "view-account-expense-type-list",
    ADD: "add-account-expense-type",
    EDIT: "edit-account-expense-type",
    DELETE: "delete-account-expense-type",
  },
  ACCOUNT_LOAN_STATUS: {
    VIEW_LIST: "view-account-loan-status-list",
    ADD: "add-account-loan-status",
    EDIT: "edit-account-loan-status",
    DELETE: "delete-account-loan-status",
  },
  ACCOUNT_BILL_STATUS: {
    VIEW_LIST: "view-account-bill-status-list",
    ADD: "add-account-bill-status",
    EDIT: "edit-account-bill-status",
    DELETE: "delete-account-bill-status",
  },
  ACCOUNT: {
    VIEW_LIST: "view-account-list",
    ADD: "add-account",
    EDIT: "edit-account",
    DELETE: "delete-account",
    VIEW_BALANCE: "view-account-balance",
  },
  ACCOUNT_VENDOR: {
    VIEW_LIST: "view-account-vendor-list",
    ADD: "add-account-vendor",
    EDIT: "edit-account-vendor",
    DELETE: "delete-account-vendor",
  },
  ACCOUNT_EXPENSE: {
    VIEW_LIST: "view-account-expense-list",
    ADD: "add-account-expense",
    EDIT: "edit-account-expense",
    DELETE: "delete-account-expense",
  },
  ACCOUNT_CUSTOMER_PAYMENT: {
    VIEW_LIST: "view-account-customer-payment-list",
    VIEW: "view-account-customer-payment",
    ADD: "add-account-customer-payment",
    EDIT: "edit-account-customer-payment",
    DELETE: "delete-account-customer-payment",
  },
  ACCOUNT_CUSTOMER_REFUND: {
    VIEW_LIST: "view-account-customer-refund-list",
    VIEW: "view-account-customer-refund",
    ADD: "add-account-customer-refund",
    EDIT: "edit-account-customer-refund",
    DELETE: "delete-account-customer-refund",
  },
  ACCOUNT_DAY_CLOSE: {
    VIEW_LIST: "view-account-day-close-list",
    ADD: "add-account-day-close",
    REOPEN: "reopen-account-day-close",
  },
  ACCOUNT_VENDOR_BILL: {
    VIEW_LIST: "view-account-vendor-bill-list",
    ADD: "add-account-vendor-bill",
    EDIT: "edit-account-vendor-bill",
    DELETE: "delete-account-vendor-bill",
  },
  ACCOUNT_VENDOR_PAYMENT: {
    VIEW_LIST: "view-account-vendor-payment-list",
    ADD: "add-account-vendor-payment",
    DELETE: "delete-account-vendor-payment",
  },
  ACCOUNT_LOAN: {
    VIEW_LIST: "view-account-loan-list",
    ADD: "add-account-loan",
    EDIT: "edit-account-loan",
    DELETE: "delete-account-loan",
  },
  ACCOUNT_LOAN_REPAYMENT: {
    VIEW_LIST: "view-account-loan-repayment-list",
    ADD: "add-account-loan-repayment",
    DELETE: "delete-account-loan-repayment",
  },
  ACCOUNT_TRANSACTION: {
    VIEW_LIST: "view-account-transaction-list",
  },
  ACCOUNT_FUND_TRANSFER: {
    VIEW_LIST: "view-account-fund-transfer-list",
    ADD: "add-account-fund-transfer",
    EDIT: "edit-account-fund-transfer",
    DELETE: "delete-account-fund-transfer",
  },
  ACCOUNT_VEHICLE_PURCHASE: {
    VIEW_LIST: "view-account-vehicle-purchase-list",
    ADD: "add-account-vehicle-purchase",
    EDIT: "edit-account-vehicle-purchase",
    DELETE: "delete-account-vehicle-purchase",
  },
  ACCOUNT_IMPORTER_PAYMENT: {
    VIEW_LIST: "view-account-importer-payment-list",
    ADD: "add-account-importer-payment",
    EDIT: "edit-account-importer-payment",
    DELETE: "delete-account-importer-payment",
  },

  ACCOUNT_RTGS_PAYMENT: {
    VIEW_LIST: "view-account-rtgs-payment-list",
    VIEW: "view-account-rtgs-payment",
    ADD: "add-account-rtgs-payment",
    EDIT: "edit-account-rtgs-payment",
    DELETE: "delete-account-rtgs-payment",
    COMPLETE: "complete-account-rtgs-payment",
  },

  RTGS_BANK_TEMPLATE: {
    VIEW_LIST: "view-rtgs-bank-template-list",
    ADD: "add-rtgs-bank-template",
    EDIT: "edit-rtgs-bank-template",
    DELETE: "delete-rtgs-bank-template",
  },

  IMPORTER_BANK_ACCOUNT: {
    VIEW_LIST: "view-importer-bank-account-list",
    ADD: "add-importer-bank-account",
    EDIT: "edit-importer-bank-account",
    DELETE: "delete-importer-bank-account",
  },

  ACCOUNT_AUDIT_LOG: {
    VIEW_LIST: "view-account-audit-log-list",
  },

  ACCOUNT_API_STATUS: {
    VIEW: "view-account-api-status",
  },

  ACTIVITY_LOG: {
    VIEW_LIST: "view-activity-log-list",
  },

  PETTY_CASH_PAYMENT_FROM: {
    VIEW_LIST: "view-petty-cash-payment-from-list",
    ADD: "add-petty-cash-payment-from",
    EDIT: "edit-petty-cash-payment-from",
    DELETE: "delete-petty-cash-payment-from",
  },

  PETTY_CASH_PAYMENT_MODE: {
    VIEW_LIST: "view-petty-cash-payment-mode-list",
    ADD: "add-petty-cash-payment-mode",
    EDIT: "edit-petty-cash-payment-mode",
    DELETE: "delete-petty-cash-payment-mode",
  },

  PETTY_CASH_PAYMENT_PURPOSE: {
    VIEW_LIST: "view-petty-cash-payment-purpose-list",
    ADD: "add-petty-cash-payment-purpose",
    EDIT: "edit-petty-cash-payment-purpose",
    DELETE: "delete-petty-cash-payment-purpose",
  },

  PETTY_CASH_TRANSACTION: {
    VIEW_LIST: "view-petty-cash-transaction-list",
    ADD: "add-petty-cash-transaction",
    EDIT: "edit-petty-cash-transaction",
    DELETE: "delete-petty-cash-transaction",
  },

  PETTY_CASH_REPORT: {
    VIEW_LIST: "view-petty-cash-report",
  },

  PETTY_CASH_BALANCE: {
    VIEW_LIST: "view-petty-cash-balance",
  },

  // Money Receipt Permissions
  MONEY_RECEIPT_PANEL: {
    VIEW: "view-money-receipt-panel",
  },
  MONEY_RECEIPT: {
    VIEW_LIST: "view-money-receipt-list",
    VIEW: "view-money-receipt",
    CREATE: "create-money-receipt",
    EDIT: "edit-money-receipt",
    DELETE: "delete-money-receipt",
    CREATE_FROM_QUOTATION: "create-money-receipt-from-quotation",
    CANCEL: "cancel-money-receipt",
    ADD_PAYMENT: "add-payment-money-receipt",
    REMOVE_PAYMENT: "remove-payment-money-receipt",
  },
  MONEY_RECEIPT_AFTER_SALE_SERVICE: {
    VIEW: "view-after-sale-service-money-receipt",
  },

  // Pre-Order Permissions
  PRE_ORDER: {
    VIEW_LIST: "view-pre-order-list",
    VIEW: "view-pre-order",
    CREATE: "create-pre-order",
    EDIT: "edit-pre-order",
    DELETE: "delete-pre-order",
    CANCEL: "cancel-pre-order",
    CREATE_MONEY_RECEIPT: "create-money-receipt-from-pre-order",
  },
  MONEY_RECEIPT_AGREEMENT: {
    VIEW: "view-agreement-money-receipt",
    EDIT: "edit-agreement-money-receipt",
  },
  MONEY_RECEIPT_LOAN: {
    VIEW: "view-loan-money-receipt",
    EDIT: "edit-loan-money-receipt",
    DELETE: "delete-loan-money-receipt",
  },
  MONEY_RECEIPT_LOAN_PDF: {
    BANK_DELIVERY_CHALLAN: "view-bank-delivery-challan-loan-pdf",
    BANK_BILL: "view-bank-bill-loan-pdf",
    CUSTOMER_MONEY_RECEIPT: "view-customer-money-receipt-loan-pdf",
    BANK_MONEY_RECEIPT: "view-bank-money-receipt-loan-pdf",
    BANK_PAYORDER_LETTER: "view-bank-payorder-letter-loan-pdf",
  },
  COMPLIMENTARY_ITEM: {
    VIEW_LIST: "view-money-receipt-complimentary-item-list",
    CREATE: "create-money-receipt-complimentary-item",
    EDIT: "edit-money-receipt-complimentary-item",
    DELETE: "delete-money-receipt-complimentary-item",
  },
}
